import React from 'react';

/**
 * Recursive function to find elements with the 'data-include-in-navigation' attribute
 * @param {FindElementsForNavigationParams} params - The parameters including the elements to search.
 * @returns {React.ReactNode[]} - The array of elements with the 'data-include-in-navigation' attribute.
 */
var findElementsForNavigation = function (_a) {
  var elements = _a.elements;
  var flattenedElements = [];
  var searchChildren = function (element) {
    var _a;
    if (!React.isValidElement(element)) return;
    var hasNavigationAttribute = element.props['data-include-in-navigation'];
    /** Only add the current element if it is a top-level element or has the navigation attribute */
    if (hasNavigationAttribute) {
      flattenedElements.push(element);
    }
    if ((_a = element.props) === null || _a === void 0 ? void 0 : _a.children) {
      React.Children.forEach(element.props.children, function (child) {
        searchChildren(child);
      });
    }
  };
  /** Process all top-level elements */
  elements.forEach(function (element) {
    var _a;
    if (React.isValidElement(element)) {
      flattenedElements.push(element);
      if ((_a = element.props) === null || _a === void 0 ? void 0 : _a.children) {
        React.Children.forEach(element.props.children, function (child) {
          searchChildren(child);
        });
      }
    }
  });
  return flattenedElements;
};

export { findElementsForNavigation };
//# sourceMappingURL=findElementsForNavigation.js.map
